import s from './styles.module.scss'
export const SeparateLine = () => {
  return <div className={s.separate} />
}
